// import * as buildUrl from "build-url";
// import { HttpParams } from "@angular/common/http";
import { isArray, isObject } from "util";

export interface RestQueryParamsEncoder {
    getQuery(query: object): string;
}

// export class RestQueryParamsEncoderHttpParams implements RestQueryParamsEncoder {
//
//     getQuery(query: object): string {
//
//         let parts = new HttpParams();
//
//         Object.keys(query).forEach(key => {
//
//             if (isObject(query[key]) && !isArray(query[key])) {
//                 parts = parts.set(key, JSON.stringify(query[key]));
//             } else if (isArray(query[key])) {
//
//                 if (query[key].find(value => value.indexOf(",") !== -1)) {
//                     throw Error("array value must not contain a comma");
//                 }
//
//                 parts = parts.set(key, query[key]);
//             } else {
//                 parts = parts.set(key, query[key]);
//             }
//         });
//
//         return parts.toString();
//     }
// }
//
// export class RestQueryParamsEncoderURLSearchParams implements RestQueryParamsEncoder {
//
//     getQuery(query: object): string {
//
//         const parts = new URLSearchParams();
//
//         Object.keys(query).forEach(key => {
//
//             if (isObject(query[key]) && !isArray(query[key])) {
//                 parts.set(key, JSON.stringify(query[key]));
//             } else if (isArray(query[key])) {
//
//                 if (query[key].find(value => value.indexOf(",") !== -1)) {
//                     throw Error("array value must not contain a comma");
//                 }
//
//                 parts.set(key, query[key]);
//             } else {
//                 parts.set(key, query[key]);
//             }
//         });
//
//         return parts.toString();
//     }
// }
//
// export class RestQueryParamsEncoderBuildUrl implements RestQueryParamsEncoder {
//
//     getQuery(query: object): string {
//
//         const queryParams = {};
//
//         Object.keys(query).forEach(key => {
//             if (isObject(query[key]) && !isArray(query[key])) {
//                 queryParams[key] = encodeURIComponent(JSON.stringify(query[key]));
//             } else if (isArray(query[key])) {
//
//                 if (query[key].find(value => value.indexOf(",") !== -1)) {
//                     throw Error("array value must not contain a comma");
//                 }
//
//                 queryParams[key] = query[key];
//             } else {
//                 queryParams[key] = encodeURIComponent(query[key]);
//             }
//         });
//
//         return buildUrl("", {
//             queryParams
//         }).substring(1);
//     }
// }

export class RestQueryParamsEncoderJson implements RestQueryParamsEncoder {

    getQuery(query: object): string {

        return encodeURIComponent(JSON.stringify(query));
    }
}



// WEBPACK FOOTER //
// ./src/core/services/api/query-params-encoder.ts